// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as AllocationDashboardRepo from "./AllocationDashboardRepo.bs.js";
import * as DummyAllocationDashboardRepo from "./DummyAllocationDashboardRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyAllocationDashboardRepo.AllocationDashboardRepo;
  } else {
    return AllocationDashboardRepo.AllocationDashboardRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
